import React from 'react';

function EmbedPreview() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="108"
      height="108"
      viewBox="0 0 108 108"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(-668 -1228)">
          <g transform="translate(531 1175)">
            <g transform="translate(137 53)">
              <path fill="#FFF" d="M0 0H108V108H0z" />
              <path
                fill="#EFEFEF"
                d="M93 99a4 4 0 014 4v5H10v-5a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V74a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V45a4 4 0 014-4h79z"
              />
              <path
                fill="currentColor"
                d="M48 13a4 4 0 014 4v11a4 4 0 01-4 4H14a4 4 0 01-4-4V17a4 4 0 014-4h34zm-15.438 4c-.937 0-1.812.375-2.624 1.188-.75.812-1.125 1.625-1.188 2.562 0 .938.313 1.75 1.063 2.5.187.188.375.313.562.438.438-.563.625-1.25.5-2.063l.125.125.25.375c.25.438.313.875.25 1.25a1.945 1.945 0 01-.688 1.188c-.5.437-.937.687-1.437.687-.438 0-.813-.188-1.188-.5-.312-.313-.5-.688-.5-1.063s.063-.75.375-1.125c-.25-.687-.375-1.375-.312-2.062-.25.188-.375.313-.563.438C26.438 21.75 26 22.563 26 23.5c0 .938.313 1.75 1.063 2.5.687.625 1.437 1 2.375 1 .375 0 .75-.063 1.062-.188.375-.125.688-.312 1.063-.562.562-.438 1-.938 1.312-1.5.125-.188.188-.375.188-.438.25-.625.25-1.25.124-1.875-.124-.625-.5-1.187-.937-1.687a3.441 3.441 0 00-1.438-.875c.063-.125.188-.313.375-.5.5-.438.938-.688 1.438-.688.438 0 .813.188 1.188.5.374.375.5.75.5 1.188 0 .313-.126.688-.376 1.063.25.562.376 1.125.376 1.687v.375c.187-.125.374-.25.5-.438.812-.812 1.187-1.687 1.187-2.625 0-.875-.375-1.687-1.063-2.375C34.25 17.375 33.5 17 32.563 17z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default EmbedPreview;



// WEBPACK FOOTER //
// ./src/components/modules/Examples/EmbedPreview.js